module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0016_C18_Final.dde154a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0016_C18_Final.jpg
// module id = Z6KU
// module chunks = 0